import React from 'react';
import '../Style/loading.css';

const Loading = ({className, title = ''}) => (
    <div className={className}>
        <div className='ball-grid-pulse'>
            <div/>
            <div/>
            <div/>
            <div/>
            <div/>
            <div/>
            <div/>
            <div/>
            <div/>
        </div>
        {title && <p>{title}</p>}
    </div>
);

export default Loading;
